module.exports = __webpack_public_path__ + "img/cooperate_31.a125aef2.png";